import React, {CSSProperties, useEffect, useState} from "react";
// import Multiselect from 'multiselect-react-dropdown';
import {useTranslation} from "react-i18next";
import  "./MultiSelectAll.css"
import { MultiSelect } from "react-multi-select-component";

interface Option {
  label: string;
  value: string;
}

interface CustomItemRendererProps {
  checked: boolean;
  option: Option;
  disabled?: boolean;
  onClick: (selectedOptions: Option[]) => void;
}

interface MultiSelectAllProps {
  options: Option[];
  value: Option[];
  handleChange: (selectedOptions: Option[]) => void;
  isReset: boolean;
  changeRefresh: (flag: boolean) => void;
  placeholder: string;
  hasSelectAll: boolean;
  ItemRenderer: (itemProps: CustomItemRendererProps) => void
}

interface MultiSelectStyles {
  multiselectContainer: CSSProperties;
  searchBox: CSSProperties;
  inputField: CSSProperties;
  chips: CSSProperties;
  optionContainer: CSSProperties;
  option: CSSProperties;
  groupHeading: CSSProperties;
}

const MultiSelectAll = (props: MultiSelectAllProps) => {
  const [selectedOptions, setSelectedOptions] = useState<Option[]>([]);
  const {t} = useTranslation();
  const options = props.options
  const value = props.value;
  const style: Partial<MultiSelectStyles> = {

    multiselectContainer: {
      width: "100%"
    }
  }

  useEffect(() => {
    if (value) {
      if (value.length === options.length) {
        setSelectedOptions([
          ...value
        ])
      } else {
        setSelectedOptions(value);
      }
    }
  }, [JSON.stringify(value)]);

  useEffect(() => {
    props.handleChange(selectedOptions);
  }, [selectedOptions]);

  useEffect(() => {
    if (props.isReset === true) {
      setSelectedOptions([])
      props.changeRefresh(false);
    }
  }, [props.isReset]);

  function onChange(value: Option[]) {
    setSelectedOptions(value);
  }

  const valueRenderer = (selected: typeof options) => {
    return props.placeholder
  };

  return (
      <MultiSelect
          className="custom-multiselect"
          valueRenderer={valueRenderer}
          overrideStrings={{
            "selectSomeItems": props.placeholder,
          }}
          options={[...options]}
          value={props.value}
          onChange={(list: Option[]) => onChange(list)}
          labelledBy="Select"
          hasSelectAll={props.hasSelectAll}
          ItemRenderer={props.ItemRenderer}
      />
  );
};

export default MultiSelectAll;
